import React, { useEffect, useState } from 'react';
import Loader from '../../../snippets/Loader';
import HosieryknittingMillForm from './HosieryknittingMillForm';
import { getMembershipFormData } from '../../../../api/membership';
import { HOSIERY_KNITTING_MILLS_FORM_SECTION } from '../../../../constants/membershipFormConstant';

const HosieryknittingMill = (props) => {
  const [defaultFields, setDefaultFields] = useState();

  useEffect(() => {
    (async () => {
      const { data: formData, error: getFormDataError } = await getMembershipFormData(
        HOSIERY_KNITTING_MILLS_FORM_SECTION,
      );
      if (formData) {
        setDefaultFields(formData.hosieryKnittingMills || {});
      } else {
        console.error(getFormDataError);
      }
    })();
  }, []);

  return defaultFields ? (
    <HosieryknittingMillForm defaultFields={defaultFields} {...props} />
  ) : (
    <Loader />
  );
};

export default HosieryknittingMill;
